import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { usePortfolio } from "@/context/PortfolioContext";

export default function Footer() {
  const { t } = useLang();
  const { visible: portfolioVisible } = usePortfolio();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0A0A] text-white pt-24 pb-10 mt-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 md:gap-12">
          <div className="col-span-12 md:col-span-6">
            <div className="az-tag text-white mb-8" style={{ color: "#FFFFFF" }}>
              <span className="az-tag__dot" />
              <span>{t.common.studio}</span>
            </div>
            <h3 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tighter">
              {t.home.statementTitle}
            </h3>
            <div className="mt-10 flex flex-wrap items-baseline gap-x-8 gap-y-3 font-mono text-[11px] tracking-widest uppercase text-white/60">
              <span>{t.common.founder}</span>
              <span>{t.common.role}</span>
              <span>{t.common.based}</span>
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] tracking-widest uppercase text-white/50 mb-6">Navigation</div>
            <ul className="space-y-3 font-sans text-[15px]">
              <li><Link to="/studio" className="hover:text-[#0055FF] transition-colors duration-300">{t.nav.about}</Link></li>
              <li><Link to="/services" className="hover:text-[#0055FF] transition-colors duration-300">{t.nav.services}</Link></li>
              <li><Link to="/industries" className="hover:text-[#0055FF] transition-colors duration-300">{t.nav.industries}</Link></li>
              {portfolioVisible && (
                <li><Link to="/portfolio" className="hover:text-[#0055FF] transition-colors duration-300">{t.nav.portfolio}</Link></li>
              )}
              <li><Link to="/process" className="hover:text-[#0055FF] transition-colors duration-300">{t.nav.process}</Link></li>
              <li><Link to="/contact" className="hover:text-[#0055FF] transition-colors duration-300">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] tracking-widest uppercase text-white/50 mb-6">Contact</div>
            <a
              data-testid="footer-email"
              href={`mailto:${t.common.email}`}
              className="font-serif text-2xl md:text-3xl leading-tight break-all hover:text-[#0055FF] transition-colors duration-300"
            >
              {t.common.email}
            </a>
            <a
              data-testid="footer-phone"
              href={`tel:${t.common.phone.replace(/[^+\d]/g, "")}`}
              className="mt-4 block font-mono text-[13px] tracking-wide text-white/80 hover:text-[#0055FF] transition-colors duration-300"
            >
              {t.common.phone}
            </a>
            <div className="mt-8 font-mono text-[11px] tracking-widest uppercase text-white/50">
              IT / EN
            </div>
          </div>
        </div>

        <div className="mt-24 h-px w-full bg-white/15" />

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 font-mono text-[10px] tracking-widest uppercase text-white/50">
          <div>© {year} · {t.common.studio}. {t.common.allRights}</div>
          <button
            type="button"
            data-testid="footer-back-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="hover:text-white transition-colors"
          >
            {t.common.backTop} ↑
          </button>
        </div>

        {/* Hidden admin entry — small monogram dot at the very bottom-right */}
        <Link
          to="/az-studio-admin"
          aria-label="Studio access"
          title=""
          data-testid="footer-admin-hidden"
          className="absolute bottom-3 right-3 md:bottom-4 md:right-6 w-2 h-2 rounded-full bg-white/25 hover:bg-[#0055FF] transition-colors duration-500"
        />
      </div>
    </footer>
  );
}
